export const POLL_INTERVAL = 3500
export const POLL_ERROR_INTERVAL = 30000
